import _objectSpread from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/chaosprint/Dev/quaver/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';

var GitHubButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(GitHubButton, _PureComponent);

  function GitHubButton(props) {
    var _this;

    _classCallCheck(this, GitHubButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GitHubButton).call(this, props));
    _this.$ = React.createRef();
    _this._ = React.createRef();
    return _this;
  }

  _createClass(GitHubButton, [{
    key: "render",
    value: function render() {
      return React.createElement('span', {
        ref: this.$
      }, React.createElement('a', _objectSpread({}, this.props, {
        ref: this._
      }), this.props.children));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.paint();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      this.reset();
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.paint();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reset();
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;

      var _ = this.$.current.appendChild(document.createElement('span'));

      import(
      /* webpackMode: "eager" */
      'github-buttons').then(function (_ref) {
        var render = _ref.render;
        render(_.appendChild(_this2._.current), function (el) {
          try {
            _.parentNode.replaceChild(el, _);
          } catch (_) {}
        });
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.$.current.replaceChild(this._.current, this.$.current.lastChild);
    }
  }]);

  return GitHubButton;
}(PureComponent);

export default GitHubButton;